import Label from '@/app/common/components/Label'
import { RadioGroup, RadioGroupItem } from '@/shad/ui/radio-group'
import React from 'react'

type Props = {
  question: string | React.ReactNode
  options: string[]
  onChange: (value: string) => void
  value?: string
  subLabel?: string
}

export default function RadioButtonQuestion(props: Props) {
  const { onChange, options, question, subLabel, value } = props

  return (
    <div className="space-y-2">
      <Label>
        {question}
        <span className="text-red-500">*</span>
        <div className="font-normal text-xs">{subLabel}</div>
      </Label>
      <RadioGroup value={value} onValueChange={onChange}>
        {options.map((answer) => {
          return (
            <div key={question + answer} className="flex space-x-2">
              <RadioGroupItem id={question + answer} value={answer} />
              <Label htmlFor={question + answer} weight={'normal'}>
                {answer}
              </Label>
            </div>
          )
        })}
      </RadioGroup>
    </div>
  )
}
